import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { ResourcePdfViewer } from './ResourcePdfViewer';

interface PDFViewerModalProps {
    /** storage.file id of the PDF, from HelpDocumentData.pdfFileId. */
    fileId: string | null | undefined;
    onClose: () => void;
}

const PDFViewerModal: React.FC<PDFViewerModalProps> = ({ fileId, onClose }) => {
    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative bg-white rounded-xl shadow-sm w-full max-w-5xl h-[85vh] p-6 flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="flex items-center justify-between pb-4 border-b border-gray-100">
                    <h3 className="text-lg font-semibold text-gray-800">Document Viewer</h3>
                    <button
                        onClick={onClose}
                        className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                        aria-label="Close PDF viewer"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-grow mt-4 overflow-hidden">
                    <ResourcePdfViewer fileId={fileId} showControls className="h-full" />
                </div>
            </div>
        </div>
    );
};

export default PDFViewerModal;
